module.exports = "/fonts/FiraSans-BoldItalic.ttf";